import React from 'react'
import Control from './control'
import Paper from '@material-ui/core/Paper'
// import { RowDetailState } from '@devexpress/dx-react-grid'
// import {
//   Grid,
//   Table,
//   TableRowDetail,
//   TableColumnResizing
// } from '@devexpress/dx-react-grid-material-ui'
import Panel from '../Panel';
import { Container } from 'reactstrap'
import { connect } from 'react-redux'

class ControlGrid extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      columns: [
        { name: 'category', title: 'Category' }
      ],
      columnWidths: [
        { columnName: 'category', width: 850 }
      ],
      rows: [],
      update: true
    }

    this.changeExpandedDetails = expandedRowIds => this.setState({ expandedRowIds })
    this.changeColumnWidths = (columnWidths) => {
      this.setState({ columnWidths })
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    //  return this.props.categories !== nextProps.categories
    // this.props.setUpdate(this.props.categories, nextProps.categories)
    // if (this.props.selectedCatName && this.props.selectedCatName.name !== nextProps.selectedCatName.name) {
    // 	return true
    // } else {
    // 	return this.state.update
    // }
    if ((this.props.selectedCatName && nextProps.selectedCatName) &&
      (this.props.selectedCatName.name !== nextProps.selectedCatName.name)) {
      return true
    } else {
      return this.props.update
      // return true
    }
  }

  componentDidUpdate (prevProps, prevState) {
    let rows
    if (prevProps.categories !== this.props.categories) {
      rows = this.props.categories.map(category => {
        if (category) {
          // this.setState({ update: false })
          this.props.setUpdate(true, true)
          return {
            category: category.name.toUpperCase(),
            number: category.controlsTotal,
            compliance: ((category.compliantControlsTotal / category.controlsTotal) * 100).toFixed(2),
            originalCategory: category.name
          }
        } else {
          return 'N/A'
        }
      })
      this.setState({ rows })
    } else {
      // this.setState({ update: true })
    }
  }

  componentDidMount () {
    this.props.setUpdate(true, false)
  }

  RowDetail ({ row }) {
    return <Control
      category={row.originalCategory}
      {...this.props} />
  };

  render () {
    // const { rows, columns, columnWidths } = this.state
    return (
      <Container className='table-container-control'
        style={this.props.sidebar.show && window.screen.width > 1024 ? { paddingLeft: '30px' } : {}}>
        <Paper style={{ minWidth: '900px' }}>
          <Panel
            title={String(this.props.lowLevelCategory).toUpperCase().substring(0, 140) +
              (String(this.props.lowLevelCategory).length > 140 ? '...' : '')}
            divider
            btns={false}
            subCollapse={true}
            subhead={this.props.layout === 2 ? (this.props.subhead || null) : null}
          >
            {this.state.rows.map((row, i) =>
              <Control key={i} category={row.originalCategory} {...this.props} />
            )}
          </Panel>
          {/* <Grid
            rows={rows}
            columns={columns}
            className='compliance-grid'

          >
            <RowDetailState
              defaultExpandedRowIds={[0]}
            />
            <Table />
            <TableColumnResizing
              columnWidths={columnWidths}
              onColumnWidthsChange={this.changeColumnWidths}

            />
            <TableRowDetail
              contentComponent={this.RowDetail.bind(this)}
              style={{ minWidth: '900px' }}
            />
          </Grid> */}
        </Paper>
      </Container>
    )
  }
}

function mapStateToProps (state) {
  return {
    sidebar: state.sidebar
  }
}

export default connect(mapStateToProps, {})(ControlGrid)



// WEBPACK FOOTER //
// ./src/components/compliance/controlGrid.js